import { useTranslation } from "react-i18next";

export const RolloverTasksReview = ({ taskData }) => {
  const { t } = useTranslation(["RolloverTasksModal"]);

  return (
    <div className="rollover-tasks-review mt-4">
      <div className="tasks-review bg-et-lightest-gray rounded p-2">
        <div className="d-flex gap-3">
          <div className="d-flex justify-content-center align-items-center number-tasks">
            {taskData?.TaskCount}
          </div>
          <div className="tasks-info">
            <div>{t("Tasks", { title: taskData?.TaskType?.Title })}</div>
            {!taskData?.SelectAllClients && (
              <div>
                {t("For")}
                {taskData?.Clients?.map((x) => x.FullName).join(", ")}
              </div>
            )}
            <div>
              {taskData?.YearFrom}
              <> → </>
              {taskData?.YearTo}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <div className="informative-banner p-2">
          <div className="px-2 pt-1">
            <i className="fa-regular fa-circle-info informative-banner-icon"></i>
          </div>
          <div className="ps-2">
            <p className="informative-banner-message">
              {t("InformativeBannerMessage")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
